import { authorizedUser } from "components/Common/commonFunctions";
import * as api from "../API/index";

export const getPartsRequestedListById = async (id) => {
  try {
    const res = await api.get_part_requested_list_by_id(id);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const updateRequestedPartsStatus = async (bodyData) => {
  try {
    const res = await api.update_request_parts_status(bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getPartsNotesByJobId = async (jobId) => {
  try {
    const res = await api.get_parts_notes_by_job_id(jobId);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const updatePartsNotesByJobId = async (jobId, bodyData) => {
  try {
    const res = await api.update_parts_notes_by_job_id(jobId, bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const exportPartsRequestCSV = async (filters) => {
  try {
    const res = await api.exportPartsRequestedCsv(filters);
    return res;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};
